import {useQuery} from '@tanstack/react-query';

import {GetListOutput, QueryOptionsForList} from '@shared/api';
import {getEventLogs, GetEventLogsParams} from '../api';
import {QUERY__EVENT_LOGS} from '../queryKeys';
import {EventLog} from '../types';

export const useGetEventLogs = <SelectedData = GetListOutput<EventLog>>(
  params: GetEventLogsParams,
  options?: QueryOptionsForList<EventLog, SelectedData>,
) =>
  useQuery({
    queryKey: [QUERY__EVENT_LOGS, params],
    queryFn: () => getEventLogs(params),
    ...options,
  });
